export const PHONE_NUMBER_LENGTH = 11
